import { defaultStore, serverTime } from '../library/firebase'

const checkMessage = serviceId => {
  return new Promise(resolve => {
    defaultStore
      .collection('messages')
      .doc(serviceId)
      .get()
      .then(doc => {
        if (doc.exists) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
  })
}

export const createMessage = (
  photographerId,
  userId,
  serviceId,
  photographerProfileImage,
  userProfileImage,
  userName,
  photographerName
) => {
  return new Promise(resolve => {
    checkMessage(serviceId).then(res => {
      if (!res) {
        defaultStore
          .collection('messages')
          .doc(serviceId)
          .set({
            createDate: serverTime,
            lastCommentDate: serverTime,
            photographerId: photographerId,
            photographerProfileImage: photographerProfileImage,
            userId: userId,
            userProfileImage: userProfileImage,
            lastComment: 'No chats yet.',
            photographerName: photographerName,
            userName: userName,
            refReservation: defaultStore
              .collection('reservations')
              .doc(serviceId)
          })
          .then(res => {
            resolve(true)
            console.log('create message response:', res)
          })
      } else {
        resolve(false)
      }
    })
  })
}

export const insertComment = (uid, serviceId, comment, name, type) => {
  return new Promise((resolve, reject) => {
    defaultStore
      .collection('messages')
      .doc(serviceId)
      .collection('detail')
      .add({
        createDate: serverTime,
        comment: comment,
        delete: false,
        name: name,
        type: type,
        uid: uid
      })
      .then(res => {
        console.log('insert message_detail response:', res)
        defaultStore
          .collection('messages')
          .doc(serviceId)
          .update({
            lastCommentDate: serverTime,
            lastComment: comment
          })
          .then(res => {
            console.log('update message response:', res)
            resolve(res)
          })
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}

export const getMessagesForPhotographer = uid => {
  return new Promise((resolve, reject) => {
    const result = []
    defaultStore
      .collection('messages')
      .where('photographerId', '==', uid)
      .get()
      .then(snap => {
        snap.forEach(doc => {
          if (doc.exists) {
            result.push(Object.assign(doc.data(), { id: doc.id }))
          }
        })
        resolve(result)
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}

export const getMessagesForUser = uid => {
  return new Promise(resolve => {
    const result = []
    defaultStore
      .collection('messages')
      .where('userId', '==', uid)
      .get()
      .then(snap => {
        snap.forEach(doc => {
          console.log('Get messages:', doc.exists)
          if (doc.exists) {
            result.push(Object.assign(doc.data(), { id: doc.id }))
          }
        })
        resolve(result)
      })
  }).catch(error => {
    console.error('Error getMessagesForUser document:', error)
  })
}

export const getMessage = serviceId => {
  return new Promise(resolve => {
    defaultStore
      .collection('messages')
      .doc(serviceId)
      .get()
      .then(doc => {
        if (doc.exists) {
          resolve(doc.data())
        }
      })
  }).catch(error => {
    console.log('Error getting document:', error)
  })
}
